import type React from "react";
import { Link } from "react-router-dom";

const MainVisual: React.FC = () => {
	return (
		<section className="relative bg-gradient-to-r from-blue-600 to-blue-800 text-white py-20 md:py-32">
			<div className="absolute inset-0 bg-grid-white/[0.2] bg-grid-16" />
			<div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="text-center">
					<h1 className="text-4xl md:text-6xl font-bold mb-6">
						<span className="block">学びを共有し、</span>
						<span className="block">共に成長する</span>
					</h1>
					<p className="text-xl md:text-2xl mb-8 text-blue-100">
						大船渡学習ギルドは、地域の仲間と一緒に学び、
						<br className="hidden md:block" />
						新しいスキルを身につけるコミュニティです。
					</p>
					<div className="flex flex-col sm:flex-row gap-4 justify-center">
						<Link
							to="/signup"
							className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-blue-700 bg-white hover:bg-blue-50 md:py-4 md:text-lg md:px-10"
						>
							無料で始める
						</Link>
						<Link
							to="/about"
							className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-500 bg-opacity-30 hover:bg-opacity-40 md:py-4 md:text-lg md:px-10"
						>
							詳しく見る
						</Link>
					</div>
				</div>
			</div>
		</section>
	);
};

export default MainVisual;
